import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import React from 'react';

export default function (props) {
	return (
		<>
			<TextField
				InputProps={{
					classes: {
						input: props.className
					}
				}}
				error={props.error}
				id="outlined-basic"
				label={props.label}
				onChange={props.onChange}
				type={props.type || 'text'}
				value={props.value}
				variant="outlined"
			/>
			<FormHelperText id="text-red">{props.error}</FormHelperText>
		</>
	);
}
